import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", notify);
      return () => {
        list.removeEventListener("change", notify);
      };
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export function useNarrow(): boolean {
  return useMediaQuery("(max-width: 1000px)");
}
